import { render } from "./LogoutIcon.vue?vue&type=template&id=28ee5049"
import script from "./LogoutIcon.vue?vue&type=script&lang=js"
export * from "./LogoutIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__